/**
 * Scroll Events
 */

import smoothScroll from './scroll/smooth-scroll';
import highlightVisible from './scroll/highlight-visible';

export default $ => {
  highlightVisible($);
  smoothScroll($);
};



// WEBPACK FOOTER //
// ./assets/js/component/scroll.js